/**
 * get the workout name of the sessions
 * @param {*} sessions
 * @param {*} week
 * @param {*} order
 * @param {*} insideSession this is to detect if we have to iterate by sessions.session or only sessions
 * @returns
 */

export function getCurrentSessionWorkoutName(
  sessions = [],
  week = 1,
  order = 1,
  insideSession = false
) {
  let workoutName = undefined;

  const compareParams = insideSession
    ? (item) => item.session.order === order && item.session.week === week
    : (item) => item.order === order && item.week === week;

  const indexToUpdate = sessions.findIndex(compareParams);

  if (indexToUpdate >= 0 && indexToUpdate < sessions.length) {
    workoutName = insideSession
      ? sessions[indexToUpdate].session.workoutName
      : sessions[indexToUpdate].workoutName;
  }

  return workoutName;
}

export const getExerciseWeek = async (api, cycleId, exerciseWeek) => {
  const res = await api("cycle-exercises", {
    query: {
      cycle: cycleId,
      program: exerciseWeek,
      week: 1,
      allWeeks: true,
    },
  });

  const response = await res.json();

  return response;
};

/**
 * A client's real, dated exercises and sections (with whatever they logged in
 * `sets[].outcomes`) for a YYYYMMDD range - same queries as the
 * weeksExercises/activeSections loaders, but callable from a mounted
 * component. `proxyAthlete` is what lets a coach read the client's data.
 */
export const getActualWeekExercises = async (
  api,
  { from, to, proxyAthlete }
) => {
  const range = { $gte: Number(from), $lte: Number(to) };
  const proxy = proxyAthlete ? { proxyAthlete } : {};

  const [exercisesRes, sectionsRes] = await Promise.all([
    api("exercise", {
      query: {
        limit: false,
        sort: { utcDate: 1, order: 1 },
        utcDate: range,
        $or: [{ cycle: { $exists: false } }, { "cycle.isScheduled": true }],
        ...proxy,
      },
    }),
    api("exercise-section", {
      query: { limit: false, sort: { order: 1 }, utcDate: range, ...proxy },
    }),
  ]);

  const [exercises, sections] = await Promise.all([
    exercisesRes.json(),
    sectionsRes.json(),
  ]);

  return {
    exercises: Array.isArray(exercises) ? exercises : [],
    sections: Array.isArray(sections) ? sections : [],
  };
};
